module.exports = __webpack_public_path__ + "fonts/FetteUNZFraktur.b6ae7a4d.eot";